import DataMgr from "@/Fwk/DataMgr";

interface RedeemChannelData {
    channel: string;
    account?: string;
    okAccount?: string;
    cardToken?: string;
    [key: string]: any;
}

class RedeemData {
    private readonly data: Record<string, any>;

    constructor() {
        let data: Record<string, any> = {}
        const loData = DataMgr.getStorage('RedeemData');
        if (loData){
            data = loData as Record<string, any>;
        }
        this.data = data;
    }

    // 获取对象值
    getObj(key: string): any {
        return this.data[key] || null;
    }

    // Getter and Setter for selectedChannel
    get selectedChannel(): string {
        return this.data["selectedChannel"] || "";
    }

    set selectedChannel(value: string) {
        this.setKey("selectedChannel", value);
    }

    // Getter and Setter for country
    get country(): string {
        return this.data["country"] || "";
    }

    set country(value: string) {
        this.setKey("country", value);
    }

    // Getter and Setter for state
    get state(): string {
        return this.data["state"] || "";
    }

    set state(value: string) {
        this.setKey("state", value);
    }

    // Getter and Setter for city
    get city(): string {
        return this.data["city"] || "";
    }

    set city(value: string) {
        this.setKey("city", value);
    }

    // Getter and Setter for zipCode
    get zipCode(): string {
        return this.data["zipCode"] || "";
    }

    set zipCode(value: string) {
        this.setKey("zipCode", value);
    }

    private setKey(key: string, value: string) {
        if (this.data[key] === value) {
            return;
        }
        this.data[key] = value;
        this.save();
    }


    setChannelAccount(channel: string, account: string) {
        this.setChannelKey(channel, "withdrawAccount", account);
    }

    setChannelOkAccount(channel: string, account: string) {
        this.setChannelKey(channel, "okAccount", account);
    }

    setChannelCardToken(channel: string, cardToken: string) {
        this.setChannelKey(channel, "cardToken", cardToken);
    }

    private setChannelKey(channel: string, key: string, value: string) {
        try {
            const channelData = (this.data["redeemChannelData"] || []) as RedeemChannelData[];

            // Find the channel object
            const channelObj = channelData.find((item) => item.channel === channel);

            if (channelObj) {
                if (channelObj[key] === value) {
                    return;
                }
                channelObj[key] = value;
            } else {
                // Add new channel object
                channelData.push({ channel, [key]: value });
            }

            this.data["redeemChannelData"] = channelData;
            this.save();
        } catch (error) {
            console.error(error);
            delete this.data["redeemChannelData"];
        }
    }

    getChannelAccount(channel: string): string {
        return this.getChannelValue(channel, "withdrawAccount");
    }

    getChannelOkAccount(channel: string): string {
        return this.getChannelValue(channel, "okAccount");
    }

    getChannelCardToken(channel: string): string {
        return this.getChannelValue(channel, "cardToken");
    }

    private getChannelValue(channel: string, key: string): string {
        try {
            const channelData = (this.data["redeemChannelData"] || []) as RedeemChannelData[];
            const channelObj = channelData.find((item) => item.channel === channel);

            return channelObj ? channelObj[key] || "" : "";
        } catch (error) {
            console.error(error);
        }
        return "";
    }

    private save() {
        // 模拟保存逻辑，例如存储到 localStorage
        console.log("Saving data:", this.data);
        try {
            DataMgr.setStorage("RedeemData", this.data);
            // DBMgr.UpdateData('RedeemData',JSON.stringify(this.data));
        }
        catch(error) {
            console.error("Error saving data:", error);
        }

    }
}

export default RedeemData;